import axios from 'axios';
import {actions} from '../reducers/PriceQuotesPageTableReducer';
import moment from 'moment';

export const CREATE_LINK = '/priceQuotes/createPriceQuoteLink';

export const createLink = ({
                             priceQuoteID,
                             sentTo,
                             notes,
                             password,
                             passwordHint,
                           }) => (dispatch) => {
  const data = {
    priceQuoteID: parseInt(priceQuoteID, 10),
    sentTo,
    notes,
    password,
    passwordHint
  };

  return axios.post(CREATE_LINK, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode === 0) {
        dispatch(actions.createLink({priceQuoteID, sentTo, sentDate: moment()}));
      } else throw new Error();
    })
    .catch(error => {
      error.clientMessage = 'Can\'t create link';
    });
};


